import { Component, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA } from "@angular/material/dialog";
import { Inject } from "@angular/core";
import { MatDialogRef } from "@angular/material/dialog";

@Component( {
    selector: 'app-error-dialog',
    templateUrl: './error-dialog.component.html',
    styleUrls: ['./error-dialog.component.scss']
} )
export class ErrorDialogComponent implements OnInit {

    constructor( @Inject( MAT_DIALOG_DATA ) public data,
        public dialogRef: MatDialogRef<ErrorDialogComponent> ) { }

    ngOnInit() {
    }

    closeDialog() {
        this.dialogRef.close( false );
    }
}
